export default __webpack_public_path__ + "static/media/sc.fc92fc67.svg";